import * as Sentry from '@sentry/browser';
import config from '@nerdwallet/app-config';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'FIXMENEEDSVERSIONINFO' : _ref$version;

  if (process.browser && config.CONFIG_ENV !== 'development' && config.SENTRY_DSN // this will be referencing BROWSER.SENTRY_DSN in app-config
  ) {
      var _ref2, _config$_meta;

      Sentry.init({
        dsn: config.SENTRY_DSN,
        environment: config.CONFIG_ENV,
        release: (_ref2 = config === null || config === void 0 ? void 0 : (_config$_meta = config['_meta']) === null || _config$_meta === void 0 ? void 0 : _config$_meta.version) !== null && _ref2 !== void 0 ? _ref2 : version
      });
    }
});